import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "ReversionDetallePage",
    data() {
        let ss = new MainService();
        return {
            msg: "ReversionDetallePage",
            ss: ss,
            ajax: {
                "url": ss.indexReversionDetalle(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'Reversion', name: 'Reversion', title: 'Reversión' },
                { data: 'Reparticion', name: 'Reparticion', title: 'Repartición' },
                { data: 'Partida', name: 'Partida', title: 'Partida' },
                { data: 'CategoriaProgramatica', name: 'CategoriaProgramatica', title: 'Categoria Programática' },
                { data: 'Monto', name: 'Monto', title: 'Monto' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            ingresoPresupuestarios: [],
            reversiondetalle: {},
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
        newReversionDetalle() {
            this.reversiondetalle = {};
            this.$refs['frm-reversiondetalle'].show();
        },
        showReversionDetalle(id) {
            this.isLoading=true;
            this.ss.showReversionDetalle(id).then(
                (result) => {
                    let response = result.data;
                    this.reversiondetalle = response.data;
                    this.$refs['view-reversiondetalle'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editReversionDetalle() {
            this.$refs['frm-reversiondetalle'].show();
            this.$refs['view-reversiondetalle'].hide();
        },
        cancelReversionDetalle() {
            if (this.reversiondetalle.id) {
                this.$refs['view-reversiondetalle'].show();
            }
            this.$refs['frm-reversiondetalle'].hide();
        },
        saveReversionDetalle() {
            this.ss.storeReversionDetalle(this.reversiondetalle).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-reversiondetalle'].hide();
                    this.$refs['datatable-reversiondetalle'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteReversionDetalle() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyReversionDetalle(this.reversiondetalle)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-reversiondetalle'].hide();
                                this.$refs['datatable-reversiondetalle'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-ReversionDetalle').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showReversionDetalle(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
          this.$router.push('/Login');
        }
    }
};
